import { render, staticRenderFns } from "./MenuTreeItem.vue?vue&type=template&id=061f2c0a&scoped=true"
import script from "./MenuTreeItem.vue?vue&type=script&lang=js"
export * from "./MenuTreeItem.vue?vue&type=script&lang=js"
import style0 from "./MenuTreeItem.vue?vue&type=style&index=0&id=061f2c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f2c0a",
  null
  
)

export default component.exports